import React from 'react';
import { Modal } from '@app/src/common/Modal/index';
import { Icon } from '@app/src/common/Icon';
import {
  Title,
  Message,
  Content,
  IconCardWrapper
} from './styled';

interface Props {
  isDisplay: boolean;
  handleClickClose?: Function;
}

export const ModalProcessPayment: React.FC<Props> = ({ isDisplay, handleClickClose }) => (
  <Modal
    customBody
    show={isDisplay}
    closeModal={handleClickClose}>
      <Content>
        <IconCardWrapper>
          <Icon data-name="icon-card" width="40" height="40" />
        </IconCardWrapper>
        <Title>Estamos procesando tu pago.</Title>
        <Message>Por favor espere un momento y no actualice la página</Message>
      </Content>
  </Modal>
);
